import { saveAs } from 'file-saver';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MuDeliveryService } from '../../../sharedProtos/delivery/mu-delivery.service';
import { Flags } from '../../../types/flags.type';
import { MuModalEvidencesFlags } from './mu-modal-evidences.flags';
import { EvidenceShared } from '../../../models/interface/evidence.interface';
import { PackageEvidenceFilterShared } from '../../../models/interface/packageEvidenceFilter.interface';

@Component({
  selector: 'app-mu-modal-evidences',
  templateUrl: './mu-modal-evidences.component.html',
  styleUrls: ['./mu-modal-evidences.component.sass'],
})
export class MuModalEvidencesComponent<FlagType> implements OnInit {
  @Input() htmlId = 'mu-evidences-modal';
  @Input() showFlag: FlagType;
  @Input() flagList: Flags<any>;
  @Input() evidenceList: EvidenceShared[];
  @Input() title: string;
  @Input() subTitle: string;
  @Input() notFound: string;
  @Input() subTitleValue: string;
  @Input() ignoreSubTitle: boolean;
  @Input() filter: PackageEvidenceFilterShared;
  isBinded: boolean;
  flagEnum = MuModalEvidencesFlags;

  constructor(private muDeliveryService: MuDeliveryService) {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * method to close evidences
   */
  close(): void {
    this.flagList.disable(this.showFlag);
  }

  /**
   * method to prev next image with key
   */
  @HostListener('document:keydown', ['$event'])
  moveImageInGallery(event: KeyboardEvent) {
    if (!this.flagList?.get(this.showFlag) || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) {
      return environment.guardClause;
    }
    const element = document?.getElementById(this.htmlId);
    if (element) {
      element.getElementsByClassName('ui-galleria-thumbnail-' + (event.key === 'ArrowLeft' ? 'prev' : 'next')).item(0) as HTMLElement;
      element.click();
    }
  }

  /**
   * download all evidences
   */
  async getEvidenceZip(): Promise<void> {
    this.flagList.enable(MuModalEvidencesFlags.LOADER);
    const response = await this.muDeliveryService.getEvidenceZip(this.evidenceList[0].orderId, this.filter);
    const file = new Blob([new Uint8Array(response)], { type: '' });
    saveAs(file, `evidences-${this.evidenceList[0].orderId}.zip`);
    this.flagList.disable(MuModalEvidencesFlags.LOADER);
  }
}
